import type {
  FigurinhaDaBiblioteca,
  RespostaDoUploadDeFigurinha,
  TipoDeFigurinha,
} from "@foto/shared";
import { enviarArquivos, type ProgressoUpload } from "../../lib/api.js";

/**
 * Sobe uma imagem para a biblioteca: `POST /api/figurinhas/upload`, multipart.
 *
 * O arquivo vai **cru**, sem passar por `reduzirImagem`: ela redesenha a imagem num canvas, e o canvas
 * devolve o que o navegador quiser onde havia transparência. O servidor mede o canal alfa do que
 * recebeu — se a tela o tivesse estragado, a figurinha seria recusada por culpa de quem a enviou certa.
 *
 * Demora: depois de receber o arquivo o servidor espera (até ~30 s) a descrição automática por visão
 * antes de responder. O progresso do envio chega a 100% bem antes de a promessa se resolver.
 */
export async function enviarFigurinha(
  arquivo: File,
  tipo: TipoDeFigurinha,
  nome: string,
  aoProgredir: (p: ProgressoUpload) => void,
): Promise<FigurinhaDaBiblioteca> {
  const nomeAparado = nome.trim();
  const resposta = await enviarArquivos<RespostaDoUploadDeFigurinha>(
    "/api/figurinhas/upload",
    { nome: "arquivo", arquivos: [arquivo] },
    aoProgredir,
    // Sem nome, o servidor usa o do arquivo: o campo nem vai.
    { tipo, ...(nomeAparado && { nome: nomeAparado }) },
  );
  return resposta.item;
}
